import { atom } from '@exodus/headless-ui';
import fromAssetAtom from './from-asset.js';
import toAssetAtom from './to-asset.js';
import fromAmountAtom from './from-amount.js';
import toAmountAtom from './to-amount.js';
const spreadAtom = atom((get, { selectors }) => {
    const fromAsset = get(fromAssetAtom);
    const toAsset = get(toAssetAtom);
    const fromAmount = get(fromAmountAtom);
    const toAmount = get(toAmountAtom);
    const getFromUsdValue = get(selectors.fiatBalances.createAssetConversionUsd(fromAsset.name));
    const getToUsdValue = get(selectors.fiatBalances.createAssetConversionUsd(toAsset.name));
    const fromUsdValue = getFromUsdValue(fromAmount);
    const toUsdValue = getToUsdValue(toAmount);
    if (fromUsdValue.isZero || toUsdValue.isZero)
        return 0;
    const spread = fromUsdValue.sub(toUsdValue).div(fromUsdValue.toDefaultNumber()).mul(100);
    return spread.toDefaultNumber();
});
export default spreadAtom;
